<div id="registration-confirmation">
    <span id="msg"></span>
    <hr>
    <a href="/">Return to start page.</a>
</div>